import { render } from "./VehicleMarker.vue?vue&type=template&id=a952c384&scoped=true"
import script from "./VehicleMarker.vue?vue&type=script&lang=js"
export * from "./VehicleMarker.vue?vue&type=script&lang=js"

import "./VehicleMarker.vue?vue&type=style&index=0&id=a952c384&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a952c384"]])

export default __exports__